<template>
  <div class="transfer-balance-wrap">
    <div class="transfer-header">{{$t('upgrade_page_views_transfer_balance_index_2339')}}</div>
    <div class="transfer-content">
      <div class="transfer-count">
        <span>{{$t('upgrade_page_views_transfer_balance_index_2340')}}</span>
        <span>{{ currencyKind }}{{ reward }}</span>
      </div>
      <div class="transfer-text">
        <p>{{$t('upgrade_page_views_transfer_balance_index_2341')}}<br />
          <strong v-if="!isEnding">{{$t('upgrade_page_views_transfer_balance_index_2342')}}<span style="color:red">{{$t('upgrade_page_views_transfer_balance_index_2343')}}</span>！
          </strong>
        </p>
      </div>
      <p class="input-title">{{$t('upgrade_page_views_transfer_balance_index_2344')}}</p>
      <input
        class="transfer-input"
        v-model="transferNumber"
        @input="validateTransferCount"
        type="text"
        :placeholder="$t('upgrade_page_views_transfer_balance_index_2345')"
      />
      <p
        class="error-text"
        :style="{ opacity: noNumber || moreNumber || zeroNumber ? '1' : '0' }"
      >
        {{
          noNumber
            ? $t('upgrade_page_views_transfer_balance_index_2346')
            : moreNumber
            ? $t('upgrade_page_views_transfer_balance_index_2347')
            : $t('upgrade_page_views_transfer_balance_index_2348')
        }}
      </p>
      <div class="transfer-btn" @click="transferBalance">
        <i v-if="transferLoading" class="el-icon-loading"></i>{{$t('upgrade_page_views_transfer_balance_index_2349')}}</div>
    </div>
  </div>
</template>

<script>
import i18n from '@/locales/index'
export default {
  data() {
    return {
      transferNumber: '',
      transferLoading: false,
      currencyKind: '$',
      reward: 0,
      moreNumber: false,
      noNumber: false,
      zeroNumber: false,
      isEnding: true
    };
  },
  watch: {
    transferNumber(newVal) {
      if (!newVal) {
        this.moreNumber = false;
        this.zeroNumber = false;
      } else if (newVal && parseInt(newVal) === 0) {
        this.noNumber = false;
        this.moreNumber = false;
      } else {
        this.zeroNumber = false;
      }
    }
  },
  created() {
    this.$store.dispatch('app/getUserAccount').then(data => {
      this.currencyKind = data.currencyKind;
      this.reward = data.reward;
    });
  },
  methods: {
    validateTransferCount({ target }) {
      const { value } = target;
      let val = value.replace(/\D/g, '');

      this.transferNumber = val;
    },
    transferBalance() {
      this.$confirm({
        content: i18n.t('upgrade_page_views_transfer_balance_index_2350'),
        confirmButtonText: i18n.t('upgrade_page_views_order_components_price_unit_305'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_42')
      }).then(() => {
        this.moreNumber =
          this.transferNumber > this.reward ||
          this.transferNumber > this.reward;
        this.noNumber = this.transferNumber === '';
        this.zeroNumber = parseInt(this.transferNumber) === 0;
        if (
          !this.noNumber &&
          !this.moreNumber &&
          !this.zeroNumber &&
          !this.transferLoading
        ) {
          this.transferLoading = true;
          // 餘額轉收入
          this.$http
            .post('/account/inner/transform', {
              amount: this.transferNumber
            })
            .then(() => {
              this.$message.success(i18n.t('upgrade_page_views_coupons_index_712'));
              this.transferLoading = false;
              this.$router.push({
                name: 'PlayerIncome'
              });
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.transfer-balance-wrap {
  width: 100%;
  height: 698px;
  margin-bottom: 60px !important;
  box-sizing: border-box;
  background: white;
  @include whiteBox;
  .transfer-header {
    width: 100%;
    height: 91px;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 31px;
    color: #333333;
    border-bottom: 2px solid #f4f4f4;
    line-height: 91px;
    padding-left: 40px;
  }
  .transfer-content {
    width: 100%;
    padding-left: 40px;
    .transfer-count {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      margin: 35px 0 14px 0;
      span:last-child {
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 31px;
        text-align: center;
        color: #38ba7c;
      }
    }
    .transfer-text {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 17px;
      letter-spacing: 0.02em;
      color: #999999;
      width: 434px;
      overflow-wrap: break-word;
      margin-bottom: 40px;
    }
    .input-title {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 8px;
      color: #666666;
    }
    .transfer-input {
      width: 434px;
      background: #f6f6f6;
      border-radius: 4px;
      height: 40px;
      line-height: 40px;
      padding-left: 10px;
      margin-bottom: 8px;
    }
    .error-text {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: #fd2243;
    }
    .transfer-btn {
      width: 191px;
      height: 48px;
      background: $color-yellow;
      margin-top: 30px;
      border-radius: 50px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      letter-spacing: -0.000319808px;
      color: $color-gray-1;
      cursor: pointer;
    }
  }
}
</style>
